/**
 * fetch支持的配置参数
 */
export var fetchSupportConfig = [
    'methods',
    'url',
    'params',
    'data',
    'withCredentials',
    'baseURL',
    'timeout',
    'postList',
    'needDeviceId',
    'commonParams',
    'metrics',
    'processPostData'
];
